import { type ExternalAccount } from '../../banking/banking/types/ExternalAccount';
import { type Member } from '../../entities/entityTypes';
import { requestBuilder } from '../../http/RequestBuilder';

export interface UnverifiedExternalAccountResponse extends ExternalAccount {
    customer: Member;
}

export const useGetUnverifiedExternalAccounts = requestBuilder.query<
    UnverifiedExternalAccountResponse[]
>({
    endpoint: () => '/api/admin/bank-ops/external-account/unverified',
    queryKey: () => '/api/admin/bank-ops/external-account/unverified',
});

export const useUpdateExternalAccount = requestBuilder.mutation<
    { success: true },
    { ids: string[]; manualReviewStatus: string }
>({
    endpoint: '/api/admin/bank-ops/external-account/',
    method: 'PATCH',
});
